/**
 * Bridges the render context to `packages/shared`'s `ColumnValueContext` (B5 §5.1).
 *
 * `toText` for the people-like types needs a display-name lookup, and the date types need the
 * viewer's timezone: `value` is always UTC, `ColumnValue.text` renders UTC, and the **UI**
 * renders in the viewer's timezone `[B5§10 case 13]`, `[09§A.7 date]`.
 */
import type { ColumnValueContext, EntityRef } from '@elizmonday/shared';
import type { CellRenderContext } from './types';

export function valueContext(context: CellRenderContext): ColumnValueContext {
  const byId = new Map(context.people.map((person) => [String(person.id), person.name]));
  return {
    timezone: context.timezone,
    resolveName: (ref: EntityRef) => byId.get(String(ref.id)),
  };
}

/** The viewer's timezone, or UTC when the browser will not say. */
export function browserTimezone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
  } catch {
    return 'UTC';
  }
}
